import React from 'react';

import { cn } from '../cn';

interface Props {
  isExpanded: boolean;
}

export const useExpander = ({ isExpanded }: Props) => {
  const triggerId = React.useId();
  const sectionId = React.useId();

  const triggerProps = {
    'aria-controls': sectionId,
    'aria-expanded': isExpanded,
    id: triggerId,
  };

  const sectionClassName = cn('grid grid-rows-0 motion-safe:transition-grid', { 'grid-rows-strict-1': isExpanded });

  const sectionProps = {
    'aria-labelledby': triggerId,
    id: sectionId,
    ...(isExpanded ? {} : { inert: '' }),
  };

  return { sectionClassName, sectionProps, triggerProps };
};
